<template>
    <Page withNavbar withNavigation>
        <header>
            <SectionTitle
                :title="config.DEPOSIT_TITLE"
                :description="config.DEPOSIT_DESCRIPTION"
            />
            <section v-if="video" class="video">
                <Video :src="video" :ratio="16/9"/>
            </section>
            <section v-else class="picture">
                <Picture :src="picture" :ratio="16/9" size="cover"/>
            </section>
        </header>
        <main>
            <section class="text">
                <p>{{ config.DEPOSIT_EXPLANATION_TITLE }}</p>
                <ul>
                    <li v-for="(instruction, index) in instructions" :key="index" :style="configStyles.primary.text">
                        <span>{{ instruction }}</span>
                    </li>
                </ul>
                <p>{{ config.DEPOSIT_EXPLANATION_PS }}</p>
            </section>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" flat :to="{ name: nextPostpone }">
                    {{ config.DEPOSIT_EXPLANATION_POSTPONE }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" :to="{ name: nextUpload }">
                    {{ config.DEPOSIT_EXPLANATION_UPLOAD }}
                </Button>
            </SectionActions>
        </main>
        <transition name="fade">
            <router-view/>
        </transition>
    </Page>
</template>
<script>
import { SolutionConsumer, CastingConsumer } from '@skeepers/platform-framework/mixins';
import { Page } from '@skeepers/platform-framework/components/mobile';
import { SectionTitle, SectionActions } from '@skeepers/platform-framework/components/shared';

export default {
    name: 'Deposit',
    components: { Page, SectionTitle, SectionActions },
    mixins: [SolutionConsumer, CastingConsumer],
    computed: {
        video () {
            return this.config.DEPOSIT_EXPLANATION_VIDEO;
        },
        picture () {
            return this.config.DEPOSIT_EXPLANATION_IMAGE_MOBILE || this.config.DEPOSIT_EXPLANATION_IMAGE;
        },
        instructions () {
            return JSON.parse(this.config.DEPOSIT_EXPLANATION_INSTRUCTIONS);
        },
        nextPostpone () {
            return this.application.progress === 'UPLOAD' ? 'deposit.complete' : 'deposit.postpone';
        },
        nextUpload () {
            return this.application.progress === 'UPLOAD' ? 'deposit.complete' : this.$route.query.next || 'upload';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';
@import '~@skeepers/platform-framework/assets/scss/colors';

header {
    > section {
        &.title {
            padding: 20px;
            text-align: center;
        }
    }
}

main {
    @include container(40px 20px);

    > section {
        &.text {
            > ul {
                padding: 0 0 0 20px;
                margin: 20px 0;

                > li {
                    line-height: 2;

                    > span {
                        color: $grey-light;
                    }
                }
            }
        }
    }
}
</style>
